"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _LayoutFullPage = _interopRequireDefault(require("crm_components/layout/LayoutFullPage"));

var _WithScrollListener = _interopRequireDefault(require("crm_components/layout/hoc/WithScrollListener"));

var BASE_CLASSNAME = 'profile-3-col-sidebar';

var ThreeColumnLayout =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ThreeColumnLayout, _PureComponent);

  function ThreeColumnLayout() {
    (0, _classCallCheck2.default)(this, ThreeColumnLayout);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ThreeColumnLayout).apply(this, arguments));
  }

  (0, _createClass2.default)(ThreeColumnLayout, [{
    key: "getBaseSidebarClassNames",
    value: function getBaseSidebarClassNames() {
      return (0, _classnames.default)('overflow-y-auto', BASE_CLASSNAME);
    }
  }, {
    key: "getSidebarClassNames",
    value: function getSidebarClassNames(side) {
      return (0, _classnames.default)(this.getBaseSidebarClassNames(), BASE_CLASSNAME + "--" + side);
    }
  }, {
    key: "getCenterClassNames",
    value: function getCenterClassNames() {
      return (0, _classnames.default)('overflow-y-auto m-x-0', BASE_CLASSNAME + "--center", {
        'width-100': this.props.isRightSidebarCollapsed
      });
    }
  }, {
    key: "getOverlayRightSidebarClassNames",
    value: function getOverlayRightSidebarClassNames() {
      return (0, _classnames.default)(BASE_CLASSNAME + "--right-wrapper", (0, _defineProperty2.default)({}, BASE_CLASSNAME + "--right-wrapper-collapsed", this.props.isRightSidebarCollapsed));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_WithScrollListener.default, {
        refName: "leftSidebarRef",
        onScroll: this.props.onLeftSidebarScroll,
        shouldListen: true
      }, _react.default.createElement(_LayoutFullPage.default, {
        centerClassName: this.getCenterClassNames(),
        centerHasRightMargin: false,
        className: "justify-center",
        leftSidebar: this.props.leftSidebar,
        leftSidebarClassName: this.getSidebarClassNames('left'),
        overlays: this.props.overlays,
        OverlaysRightSidebar: this.props.OverlaysRightSidebar,
        overlayRightSidebarWrapperClassName: this.getOverlayRightSidebarClassNames(),
        overlayRightOffsetX: 16,
        pageHeader: this.props.pageHeader,
        pageHeaderHasMargin: false,
        rightSidebar: this.props.rightSidebar,
        rightSidebarClassName: this.getSidebarClassNames('right'),
        rootClassName: "profile-3-column",
        topFullWidth: this.props.topFullWidth
      }, this.props.children));
    }
  }]);
  return ThreeColumnLayout;
}(_react.PureComponent);

ThreeColumnLayout.propTypes = {
  OverlaysRightSidebar: _propTypes.default.array,
  children: _propTypes.default.node,
  isRightSidebarCollapsed: _propTypes.default.bool,
  leftSidebar: _propTypes.default.node,
  onLeftSidebarScroll: _propTypes.default.func,
  overlays: _propTypes.default.array,
  pageHeader: _propTypes.default.node,
  rightSidebar: _propTypes.default.node,
  topFullWidth: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.array])
};
var _default = ThreeColumnLayout;
exports.default = _default;
module.exports = exports.default;